<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import bus from '@/bus'
export default {
  name: 'App',
  created() {
    bus.subscribe(this, 'auth/userLoggedOut', () => {
      this.$router.push({ name: 'login' })
    })
  }
}
</script>
